// extracted by mini-css-extract-plugin
module.exports = {"loading-spinner":"_15pMnDN3c6Krf9mcNONg_H"};